import { render, staticRenderFns } from "./BasePhoneInput.vue?vue&type=template&id=208e8ebc&scoped=true"
import script from "./BasePhoneInput.vue?vue&type=script&lang=js"
export * from "./BasePhoneInput.vue?vue&type=script&lang=js"
import style0 from "./BasePhoneInput.vue?vue&type=style&index=0&id=208e8ebc&prod&lang=scss&scoped=true"
import style1 from "./BasePhoneInput.vue?vue&type=style&index=1&id=208e8ebc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208e8ebc",
  null
  
)

export default component.exports